import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import MappingListPageUI from './MappingListPageUI.js'

class MappingListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      mappingList: null,
      createMode: false,
      createMappingGroup: null,
      updateMode: false,
      selectedMapping: null,
      mappedValueList: null,
      codeLabelList: null,
      paymentCategoryList: null
    }
  }

  render() {
    return (
      <MappingListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        mappingList={this.state.mappingList}
        paymentCategoryList={this.state.paymentCategoryList}
        selectedMapping={this.state.selectedMapping}
        createMode={this.state.createMode}
        updateMode={this.state.updateMode}
        mappingGroup={this.state.createMappingGroup}
        mappedValueList={this.state.mappedValueList}
        codeLabelList={this.state.codeLabelList}
        // events
        onRefreshClick={this.onRefreshClick}
        onOpenCreateModal={this.onOpenCreateModal}
        onUpdateClick={this.onUpdateClick}
        onDeleteClick={this.onDeleteClick}
        onCancelClick={this.onCancelClick}
        onUpdate={this.onUpdate}
      />
    )
  }

  componentDidMount() {
    console.log('componentDidMount');
    let context = this.props.context
    this.getMappings(context)
    this.getBankAnalyzerCategories(context)
    this.getPaymentCategoriesMappings(context)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.mappingGroup == this.props.match.params.mappingGroup)
      return

    let context = this.props.context
    this.getMappings(context)
  }

  getMappings(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/mappings/${this.props.match.params.mappingGroup}`,
      cacheKey: CacheKeys.Mappings(this.props.match.params.mappingGroup),
      callback: this.getMappingsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getMappingsCallback = (response) => {
    this.setState({ errorList: response.errorList, mappingList: response.mappingList })
  }

  getPaymentCategoriesMappings(context) {
    console.log('Loading payment categories');
    let cacheManager = new CacheManager({
      resource: '/api/su/mappings/bank_analyzer_payment_category',
      cacheKey: CacheKeys.Mappings('bank_analyzer_payment_category'),
      callback: this.getPaymentCategoriesMappingsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getPaymentCategoriesMappingsCallback = (response) => {
    this.setState({
      paymentCategoryList: response.mappingList
    })
  }

  onUpdateClick = (event) => {
    let mappingId = event.currentTarget.getAttribute('data-mapping-id')

    const selectedMapping =
      [...this.state.mappingList,
      ...this.state.paymentCategoryList]
        .find(p => p.mappingId === mappingId);

    console.log('selectedMapping', selectedMapping);

    this.setState({
      updateMode: true,
      selectedMapping: selectedMapping
    })
  }

  onCancelClick = () => {
    this.setState({
      createMode: false, updateMode: false,
      createMappingGroup: null, errorList: null
    })
  }

  onUpdate = (selectedMapping) => {
    CacheManager.removeObject(CacheKeys.Mappings(this.props.match.params.mappingGroup))
    CacheManager.removeObject(CacheKeys.Mappings('bank_analyzer_payment_category'))

    this.setState({ mappingList: this.state.mappingList })
    this.getPaymentCategoriesMappings(this.props.context)
  }

  onDeleteClick = (event) => {
    const mappingId =
      event.currentTarget.getAttribute('data-mapping-id')

    const mapping =
      this.state.paymentCategoryList.find(
        p => p.mappingId === mappingId
      )

    RestApiUtils.put(
      this.props.context,
      `/api/su/mappings/bank_analyzer_payment_category/mappingId/${mappingId}`,
      this.onDeleteCallback,
      {
        sourceValue: '',
        mappedValue: mapping.mappedValue,
        ignoreSpaces: mapping.ignoreSpaces
      }
    )
  }

  onDeleteCallback = (response) => {
    CacheManager.removeObject(
      CacheKeys.Mappings('bank_analyzer_payment_category')
    )
    this.getPaymentCategoriesMappings(this.props.context)
  }

  getBankAnalyzerCategories(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/bankAnalyzerCategories`,
      cacheKey: CacheKeys.BankAnalyzerCategories(),
      callback: this.getBankAnalyzerCategoriesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBankAnalyzerCategoriesCallback = (response) => {
    let mappedValueList = response.codeLabelList.map(cat => ({ key: cat.code, value: cat.label }))
    this.setState({
      mappedValueList: mappedValueList,
      codeLabelList: response.codeLabelList
    })
  }

  onRefreshClick = () => {
    CacheManager.removeObject(
      CacheKeys.Mappings(this.props.match.params.mappingGroup)
    )

    CacheManager.removeObject(
      CacheKeys.Mappings('bank_analyzer_payment_category')
    )

    CacheManager.removeObject(
      CacheKeys.BankAnalyzerCategories()
    )

    this.setState({
      mappingList: null,
      paymentCategoryList: null,
      errorList: null
    })

    this.getMappings(this.props.context)
    this.getPaymentCategoriesMappings(this.props.context)
    this.getBankAnalyzerCategories(this.props.context)
  }
  onOpenCreateModal = (mappingGroup) => {
    this.setState({
      createMode: true,
      createMappingGroup: mappingGroup
    })
  }
}

export default withRouter(MappingListPageSF)
